/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldDatensatzWeg } from './DatabaseFieldDatensatzWeg';
import {
    DatabaseFieldDatensatzWegFromJSON,
    DatabaseFieldDatensatzWegFromJSONTyped,
    DatabaseFieldDatensatzWegToJSON,
} from './DatabaseFieldDatensatzWeg';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlock } from './DatabasePageBlock';
import {
    DatabasePageBlockFromJSON,
    DatabasePageBlockFromJSONTyped,
    DatabasePageBlockToJSON,
} from './DatabasePageBlock';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';

/**
 * 
 * @export
 * @interface DatabaseFieldPageBlock
 */
export interface DatabaseFieldPageBlock extends DatabasePageBlock {
    /**
     * Contains the field ID of the field to extract the content from
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    fontFamily?: string;
    /**
     * 
     * @type {DatabaseFontSizeEnum}
     * @memberof DatabaseFieldPageBlock
     */
    fontSize?: DatabaseFontSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    fontColor?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldPageBlock
     */
    isInput?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseFieldPageBlock
     */
    isCompact?: boolean;
    /**
     * Wenn true, wird das Feld auf die gesamte Blockbreite ausgedehnt
     * @type {boolean}
     * @memberof DatabaseFieldPageBlock
     */
    fullWidth?: boolean;
    /**
     * Die Unterdatenbank, aus der das Feld kommt. Leer heisst: das
     * Feld der eigenen Datenbank — so, wie es bisher war.
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    datenbankId?: string;
    /**
     * Kennung eines ZAHLENFELDES des geoeffneten Datensatzes. Steht
     * dort 3, gilt das Feld, das `feldMuster` mit 3 ergibt.
     * 
     * WOFUER: Die Scorecard hat je Spieler 18 Felder („Bahn 1" …
     * „Bahn 18") und ein Feld „Aktuelle Bahn". Ohne diesen Weg
     * braeuchte es dafuer weiterhin den alten Listen-Baustein.
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    feldWechseltMit?: string;
    /**
     * Namensmuster fuer `feldWechseltMit`, etwa „Bahn {n}". `{n}`
     * steht fuer die Zahl.
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    feldMuster?: string;
    /**
     * 
     * @type {DatabaseFieldDatensatzWeg}
     * @memberof DatabaseFieldPageBlock
     */
    datensatzWeg?: DatabaseFieldDatensatzWeg;
    /**
     * Nur bei `datensatzWeg: VERGLEICH`: das Feld der Unterdatenbank,
     * das verglichen wird (Bahnen.Nummer).
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    vergleichKindFeldId?: string;
    /**
     * Nur bei `datensatzWeg: VERGLEICH`: das Feld des geoeffneten
     * Datensatzes, mit dem verglichen wird (Runde.Aktuelle Bahn).
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    vergleichElternFeldId?: string;
    /**
     * Nur bei `datensatzWeg: BESTIMMT`.
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    datensatzId?: string;
    /**
     * Nur bei `datensatzWeg: ALLE`: das Feld, das VOR dem Wert steht
     * — bei den Spielern ihr Name. Ohne Angabe stehen nur die Werte
     * untereinander.
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    beschriftungFeldId?: string;
    /**
     * Zwei Knoepfe am Zahlenfeld (nur mit `isInput`). Sie ersetzen
     * den Zaehler des alten Listen-Bausteins.
     * @type {boolean}
     * @memberof DatabaseFieldPageBlock
     */
    mitPlusMinus?: boolean;
    /**
     * Hintergrund des Datenfeldes. Leer heisst durchsichtig.
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    feldHintergrund?: string;
    /**
     * Rahmen des Datenfeldes in Pixeln; 0 heisst kein Rahmen.
     * @type {number}
     * @memberof DatabaseFieldPageBlock
     */
    feldRahmenBreite?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseFieldPageBlock
     */
    feldRahmenRundung?: number;
    /**
     * Leer heisst grau — nie weiss (siehe `ohneWeissenRahmen`).
     * @type {string}
     * @memberof DatabaseFieldPageBlock
     */
    feldRahmenFarbe?: string;
}

/**
 * Check if a given object implements the DatabaseFieldPageBlock interface.
 */
export function instanceOfDatabaseFieldPageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseFieldPageBlockFromJSON(json: any): DatabaseFieldPageBlock {
    return DatabaseFieldPageBlockFromJSONTyped(json, false);
}

export function DatabaseFieldPageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseFieldPageBlock {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabasePageBlockFromJSONTyped(json, ignoreDiscriminator),
        'content': !exists(json, 'content') ? undefined : json['content'],
        'fontFamily': !exists(json, 'fontFamily') ? undefined : json['fontFamily'],
        'fontSize': !exists(json, 'fontSize') ? undefined : DatabaseFontSizeEnumFromJSON(json['fontSize']),
        'fontColor': !exists(json, 'fontColor') ? undefined : json['fontColor'],
        'isInput': !exists(json, 'isInput') ? undefined : json['isInput'],
        'isCompact': !exists(json, 'isCompact') ? undefined : json['isCompact'],
        'fullWidth': !exists(json, 'fullWidth') ? undefined : json['fullWidth'],
        'datenbankId': !exists(json, 'datenbankId') ? undefined : json['datenbankId'],
        'feldWechseltMit': !exists(json, 'feldWechseltMit') ? undefined : json['feldWechseltMit'],
        'feldMuster': !exists(json, 'feldMuster') ? undefined : json['feldMuster'],
        'datensatzWeg': !exists(json, 'datensatzWeg') ? undefined : DatabaseFieldDatensatzWegFromJSON(json['datensatzWeg']),
        'vergleichKindFeldId': !exists(json, 'vergleichKindFeldId') ? undefined : json['vergleichKindFeldId'],
        'vergleichElternFeldId': !exists(json, 'vergleichElternFeldId') ? undefined : json['vergleichElternFeldId'],
        'datensatzId': !exists(json, 'datensatzId') ? undefined : json['datensatzId'],
        'beschriftungFeldId': !exists(json, 'beschriftungFeldId') ? undefined : json['beschriftungFeldId'],
        'mitPlusMinus': !exists(json, 'mitPlusMinus') ? undefined : json['mitPlusMinus'],
        'feldHintergrund': !exists(json, 'feldHintergrund') ? undefined : json['feldHintergrund'],
        'feldRahmenBreite': !exists(json, 'feldRahmenBreite') ? undefined : json['feldRahmenBreite'],
        'feldRahmenRundung': !exists(json, 'feldRahmenRundung') ? undefined : json['feldRahmenRundung'],
        'feldRahmenFarbe': !exists(json, 'feldRahmenFarbe') ? undefined : json['feldRahmenFarbe'],
    };
}

export function DatabaseFieldPageBlockToJSON(value?: DatabaseFieldPageBlock | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabasePageBlockToJSON(value),
        'content': value.content,
        'fontFamily': value.fontFamily,
        'fontSize': DatabaseFontSizeEnumToJSON(value.fontSize),
        'fontColor': value.fontColor,
        'isInput': value.isInput,
        'isCompact': value.isCompact,
        'fullWidth': value.fullWidth,
        'datenbankId': value.datenbankId,
        'feldWechseltMit': value.feldWechseltMit,
        'feldMuster': value.feldMuster,
        'datensatzWeg': DatabaseFieldDatensatzWegToJSON(value.datensatzWeg),
        'vergleichKindFeldId': value.vergleichKindFeldId,
        'vergleichElternFeldId': value.vergleichElternFeldId,
        'datensatzId': value.datensatzId,
        'beschriftungFeldId': value.beschriftungFeldId,
        'mitPlusMinus': value.mitPlusMinus,
        'feldHintergrund': value.feldHintergrund,
        'feldRahmenBreite': value.feldRahmenBreite,
        'feldRahmenRundung': value.feldRahmenRundung,
        'feldRahmenFarbe': value.feldRahmenFarbe,
    };
}

